<div fxLayout="column" fxFlexFill *ngIf="!loaders.page">

    <div class="divider layout-padd-2" ngClass.xs="layout-padd" fxLayoutAlign="start center" fxLayoutGap="10px">

        <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>

        <div fxLayout="column">
            <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>
            <span class="mat-title boldest">{{(checkMerchantOptions(15) ? "cashlessOptionComponent.card" :"cashlessOptionComponent.kity" )|translate}}</span>
        </div>

    </div>

    <div class="scrolled light-grey" style="padding: 10px;" fxFlex>

        <mat-grid-list [cols]="respCols" [rowHeight]="respHeight" gutterSize="10">

            <!-- Cashless -->
            <mat-grid-tile class="clicked merchant-option-tile rad-bord clicked" angulartics2On="click" angularticsAction="goRecharge" angularticsCategory="cashlessOptions" *ngIf="checkMerchantOptions(15) || checkMerchantOptions(2)" (click)="goRecharge()">

                <div fxLayout="column" fxLayoutGap="10px" class="whited layout-padd" fxFlexFill>

                    <div fxLayout="row" fxLayout.xs="column" fxFlex>

                        <div fxLayout="column" fxFlex=50 fxLayoutAlign="center center" class="layout-padd rad-bord light-grey" style="position: relative; overflow: hidden;">

                            <div  ngClass.xs="blocked-card-xs" class="layout-padd warn-ico " style="position: absolute;top: 0;left: 0; border-bottom-right-radius: 5px;" *ngIf="merchantClient.archive === 1">
                                <span class="mat-subheading-1">{{"cashlessOptionComponent.blockedCard"|translate}}</span>
                            </div>

                            <span class="boldest price-title" ngClass.xs="price-title-xs">{{(merchantClient.credit_amount ? merchantClient.credit_amount:0) | priceFilter:currMerchant.currency.symbol}}</span>
                            <!-- <span class="mat-subheading-1">{{currMerchant.currency.symbol}}</span> -->



                        </div>

                        <div fxFlex fxLayout="column" fxLayoutAlign="center center" class="text-center rad-bord layout-padd">

                            <div fxLayoutAlign="center center" class="dark whited-ico layout-padd tile-ico">
                                <i class="far fa-credit-card whited-ico"></i>
                            </div>

                            <span class="mat-subheading-1 boldest">{{"cashlessOptionComponent.charge"|translate}}</span>

                        </div>

                    </div>

                </div>

            </mat-grid-tile>

            <!-- Refills history -->
            <mat-grid-tile class="clicked merchant-option-tile rad-bord clicked" angulartics2On="click" angularticsAction="goRefillsHistory" angularticsCategory="cashlessOptions" (click)="goHistory()">

                <div fxLayout="row" fxLayoutGap="10px" class="whited layout-padd" fxFlexFill>

                    <div fxFlex fxLayout="column" fxLayoutAlign="center center" class="text-center rad-bord layout-padd">

                        <div fxLayoutAlign="center center" class="dark whited-ico layout-padd tile-ico">
                            <i class="fas fa-history whited-ico"></i>
                        </div>

                        <span class="mat-subheading-1 boldest">{{"cashlessOptionComponent.chargeHistory"|translate}}</span>

                    </div>

                </div>

            </mat-grid-tile>

            <!-- Block/Unblock card -->
            <mat-grid-tile class="clicked merchant-option-tile rad-bord clicked" angulartics2On="click" angularticsAction="{{(merchantClient.archive === 0) ? 'blockCard' : 'unblockCard'}}" angularticsCategory="cashlessOptions" *ngIf="checkMerchantOptions(15)" (click)="openConfirmBlockCard()">

                <div fxLayout="row" fxLayoutGap="10px" class="whited layout-padd" fxFlexFill>

                    <div fxFlex fxLayout="column" fxLayoutAlign="center center" class="text-center rad-bord layout-padd" [class.warn-ico]="merchantClient.archive === 0" [class.great-ico]="merchantClient.archive === 1">

                        <div fxLayoutAlign="center center" class="great layout-padd tile-ico" *ngIf="merchantClient.archive === 1">
                            <i class="fas fa-lock-open whited-ico"></i>
                        </div>

                        <div fxLayoutAlign="center center" class="warn layout-padd tile-ico" *ngIf="merchantClient.archive === 0">
                            <i class="fas fa-lock whited-ico"></i>
                        </div>

                        <span class="mat-subheading-1 boldest">{{(merchantClient.archive === 1 ? "cashlessOptionComponent.unblockCard" :"cashlessOptionComponent.blockCard" )|translate}}</span>

                    </div>

                </div>

            </mat-grid-tile>

        </mat-grid-list>

    </div>

</div>

<!--
<app-popup-loader [flagLoading]="loaders.page" [size]="30" [statusMessage]="statusMessage">
</app-popup-loader>-->
